import React from "react";

import filterImagesForCoverImage from "shared/utils/filters/productImageFilter";
import imagePlaceholder from "shared/resources/thumbnail-product-placeholder.png";

const OrderUnitImage = props => {
  const { orderUnit, className } = props;
  if (!orderUnit) {
    return null;
  }

  let orderUnitImages;
  let image;

  if (orderUnit.images && orderUnit.images.length > 0) {
    orderUnitImages = orderUnit.images;
  } else if (
    orderUnit.products &&
    orderUnit.products.length > 0 &&
    orderUnit.products[0].images &&
    orderUnit.products[0].images.length > 0
  ) {
    orderUnitImages = orderUnit.products[0].images;
  }

  if (orderUnitImages) {
    image = filterImagesForCoverImage(orderUnitImages, "thumbnail");
  }
  const finalClassName = className
    ? `${className} order-unit-thumbnail`
    : "order-unit-thumbnail";

  return (
    <div className={finalClassName}>
      <img src={image || imagePlaceholder} alt={orderUnit.name} />
    </div>
  );
};

export default OrderUnitImage;
